import { UserOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Typography } from "antd";
import { useEffect, useState } from "react";

const ReceiverFormModal = ({ visible, onClose, onSave, initialValues, loading }) => {
  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState({});

  const isValid =
    /^[a-zA-ZÀ-ỹ\s]+$/.test(formValues?.fullName || "") && /^(0[3|5|7|8|9])+([0-9]{8})$/.test(formValues?.phone || "");

  useEffect(() => {
    if (visible) {
      const vals = initialValues?.id
        ? { fullName: initialValues.fullName, phone: initialValues.phone }
        : { fullName: "", phone: "" };
      form.setFieldsValue(vals);
      setFormValues(vals);
    } else {
      form.resetFields();
      setFormValues({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const handleOk = async () => {
    const values = await form.validateFields();
    await onSave(values);
  };

  return (
    <Modal
      title={
        <Typography.Text strong style={{ fontSize: 15 }}>
          {initialValues?.id ? "Sửa người nhận" : "Thêm người nhận mới"}
        </Typography.Text>
      }
      visible={visible}
      onCancel={onClose}
      onOk={handleOk}
      confirmLoading={loading}
      okText="Lưu"
      cancelText="Hủy"
      width={420}
      centered
      okButtonProps={{ disabled: !isValid }}
    >
      <Form form={form} layout="vertical" style={{ marginTop: 8 }} onValuesChange={(_, all) => setFormValues(all)}>
        <Form.Item
          label="Họ và tên"
          name="fullName"
          rules={[
            { required: true, message: "Vui lòng nhập họ tên" },
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve();
                if (/^[a-zA-ZÀ-ỹ\s]+$/.test(value)) return Promise.resolve();
                return Promise.reject(new Error("Họ tên chỉ được chứa chữ cái"));
              },
            },
          ]}
        >
          <Input
            prefix={<UserOutlined style={{ color: "#9CA3AF" }} />}
            placeholder="Nhập họ tên người nhận"
            size="large"
          />
        </Form.Item>
        <Form.Item
          label="Số điện thoại"
          name="phone"
          rules={[
            { required: true, message: "Vui lòng nhập số điện thoại" },
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve();
                if (/^(0[3|5|7|8|9])+([0-9]{8})$/.test(value)) return Promise.resolve();
                return Promise.reject(new Error("Số điện thoại không đúng định dạng"));
              },
            },
          ]}
          style={{ marginBottom: 0 }}
        >
          <Input
            placeholder="Nhập số điện thoại"
            size="large"
            onKeyDown={(e) => {
              if (!/[0-9]/.test(e.key) && !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)) {
                e.preventDefault();
              }
            }}
            maxLength={10}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ReceiverFormModal;
